/* eslint-disable @typescript-eslint/no-explicit-any */
import { FabricObject, FabricImage } from 'fabric';

/**
 * Список кастомных свойств Fabric объектов для сериализации и восстановления.
 * Используется в toObject() для сериализации и в loadObjectsWithLayers для восстановления.
 */
export const FABRIC_CUSTOM_PROPERTIES = [
  'id',
  'name',
  'layer',
  'zIndex',
  'category',
  'idGroup',
  'slide_width',
  'slide_height',
  'source_width',
  'source_height',
  'backgroundColor',
  'backgroundImage',
  'noCopy',
  'icons',
  'shapes',
  'isNeedScaleImgForFirstRender',
  'available_images',
  'shape_type',
  'media_type',
  'clip_path',
  'source_ext',
  'margin',
  'space',
  'inner_id',
  'imageColor',
  'missing_items',
  'originalOpacity',
  'isOpacityChangeFromSelection',
  'isLocked',
  'crop',
  'originalLockState',
  'alternative_text',
  'is_truncated',
  'extra_info',
  'textId',
  'isChangedContent',
  'originalText',
  'isBulletWithoutIcon',
  'source_type',
  // Поля метабуллитов
  'entityType',
  'metaBulletId',
  'entityOrder',
  'bulletLevel',
  'isMetaBulletEntity',
  'marginBottom',
  'marginLeft',
  'excludeFromBackup',
] as const;

const originalToObject = FabricObject.prototype.toObject;

FabricObject.prototype.toObject = function (additionalProperties: string[] = []) {
  const customValues: Record<string, unknown> = {};
  FABRIC_CUSTOM_PROPERTIES.forEach((prop) => {
    customValues[prop] = (this as any)[prop];
  });

  return {
    ...originalToObject.call(this, additionalProperties),
    ...customValues,
  };
};

FabricObject.prototype.objectCaching = true;
FabricImage.prototype.objectCaching = true;
